import React from 'react'
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import { alpha } from '@mui/material/styles'

import {
  UI_COLOR_ACCENT_ORANGE,
  UI_COLOR_ACCENT_ORANGE_SOFT_HOVER,
  UI_COLOR_BORDER_LIGHT,
  UI_COLOR_SECONDARY,
  UI_COLOR_SURFACE_SOFT,
  UI_COLOR_TEXT_MUTED_LIGHT,
  UI_COLOR_TEXT_NAVY,
  UI_COLOR_WHITE
} from '../constants/uiColors'

export default function LeftTabsMui({
  tabs = [],
  activeTab,
  onChange,
  title,
  stickyTop = 24,
  width = 220,
  sx = {}
}) {
  return (
    <Box
      sx={{
        border: `1px solid ${UI_COLOR_BORDER_LIGHT}`,
        borderRadius: '14px',
        p: 1.25,
        position: { md: 'sticky' },
        top: { md: stickyTop },
        bgcolor: UI_COLOR_WHITE,
        width: { md: width },
        ...sx
      }}
    >
      {title ? (
        <Typography
          sx={{
            px: 1,
            pt: 0.5,
            pb: 1,
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            color: UI_COLOR_TEXT_MUTED_LIGHT
          }}
        >
          {title}
        </Typography>
      ) : null}
      <List disablePadding>
        {tabs.map((tab) => {
          const selected = tab.value === activeTab
          const Icon = tab.icon

          return (
            <ListItemButton
              key={tab.value}
              selected={selected}
              onClick={() => onChange?.(tab.value, tab)}
              sx={{
                minHeight: 44,
                borderRadius: '8px',
                mb: 0.75,
                px: 1.75,
                '&.Mui-selected': {
                  bgcolor: UI_COLOR_ACCENT_ORANGE_SOFT_HOVER,
                  '&:hover': { bgcolor: alpha(UI_COLOR_ACCENT_ORANGE, 0.14) }
                },
                '&:hover': { bgcolor: UI_COLOR_SURFACE_SOFT }
              }}
            >
              {Icon ? (
                <ListItemIcon
                  sx={{
                    minWidth: 32,
                    color: selected ? UI_COLOR_ACCENT_ORANGE : UI_COLOR_SECONDARY
                  }}
                >
                  {React.isValidElement(Icon) ? Icon : <Icon sx={{ fontSize: 19 }} />}
                </ListItemIcon>
              ) : null}
              <ListItemText
                primary={tab.label}
                primaryTypographyProps={{
                  fontSize: 13.5,
                  fontWeight: 800,
                  color: selected ? UI_COLOR_TEXT_NAVY : UI_COLOR_SECONDARY
                }}
              />
            </ListItemButton>
          )
        })}
      </List>
    </Box>
  )
}
